import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const AdminLayout = ({ module, title, children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isSidebarOpen, setSidebarOpen] = useState(true);

  const onLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className={`admin-shell ${isSidebarOpen ? "" : "sidebar-collapsed"}`.trim()}>
      <aside className="admin-sidebar">
        <div className="admin-logo">{module.logo}</div>
        <nav className="admin-nav">
          {module.navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => `admin-nav-link ${isActive ? "is-active" : ""}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <main className="admin-main">
        <header className="admin-topbar">
          <div className="topbar-title-wrap">
            <button
              type="button"
              className="sidebar-toggle-btn"
              onClick={() => setSidebarOpen((prev) => !prev)}
              aria-label={isSidebarOpen ? "Collapse sidebar" : "Expand sidebar"}
              title={isSidebarOpen ? "Collapse sidebar" : "Expand sidebar"}
            >
              ☰
            </button>
            {/* Modules like E-Paper Admin only show their own nav items in the
                sidebar, so this is the only way back to the main dashboard
                once you've navigated into one. Always visible, unlike the
                sidebar, which can be collapsed or hidden on small screens. */}
            <Link to="/" className="topbar-home-link" title="Back to Dashboard">
              ← Dashboard
            </Link>
            <h1>{title}</h1>
          </div>
          <div className="topbar-actions">
            <div className="profile-pill" title={user?.name || "Profile"}>
              {user?.name?.charAt(0)?.toUpperCase() || "A"}
            </div>
            <button
              type="button"
              className="topbar-logout"
              onClick={onLogout}
              title="Log out"
            >
              Logout
            </button>
          </div>
        </header>
        <section className="admin-content">{children}</section>
      </main>
    </div>
  );
};

export default AdminLayout;
